import { ItemCard } from "@/components/ItemCard";
import { useModals } from "@/features/modals/hooks";
import { Text, crossIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { FlexDiv } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

export const NotFoundDrawingCard = ({
  editable,
  onDisassociate,
  drawingId,
}: {
  editable: boolean;
  drawingId: string;
  onDisassociate?: (id: string) => void;
}) => {
  const { pushModal } = useModals();

  const menuItems = [
    {
      icon: crossIcon,
      title: t("action.remove_from_project"),
      onClick: () => {
        pushModal({
          type: "CONFIRM",
          onConfirm: () => onDisassociate?.(drawingId),
          title: t("action.remove_from_project"),
          message: t("prompt.confirm_remove_drawing"),
        });
        trackAnalytics("remove_drawing_from_project");
      },
    },
  ];
  return (
    <ItemCard
      editable={editable}
      menuItems={menuItems}
      details={
        <FlexDiv flexDirection="column" width="100%">
          <Text textStyle="Heading.XS">{drawingId}</Text>
          <Text>{t("prompt.drawing_not_found")}</Text>
        </FlexDiv>
      }
    />
  );
};
